var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (_vm.shortcut.image && Object.keys(_vm.shortcut.image).length) ||
    _vm.shortcut.icon
    ? _c(
        "div",
        {
          staticClass:
            "global-quicksearch-shortcut global-quicksearch-shortcut--illustrated",
        },
        [
          _c(
            "div",
            { staticClass: "global-quicksearch-shortcut__image" },
            [
              _vm.shortcut.image && Object.keys(_vm.shortcut.image).length
                ? _c("global-responsive-image", {
                    attrs: { "responsive-image": _vm.shortcut.image },
                  })
                : _vm.shortcut.icon
                ? _c("global-icon", { attrs: { icon: _vm.shortcut.icon } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "global-quicksearch-shortcut__content" }, [
            _c("h3", { staticClass: "shortcut__header" }, [
              _vm._v(_vm._s(_vm.shortcut.headline)),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "shortcut__body",
              domProps: { innerHTML: _vm._s(_vm.shortcut.bodytext) },
            }),
          ]),
        ]
      )
    : _c("div", { staticClass: "global-quicksearch-shortcut" }, [
        _c("h3", { staticClass: "shortcut__header" }, [
          _vm._v(_vm._s(_vm.shortcut.headline)),
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "shortcut__body",
          domProps: { innerHTML: _vm._s(_vm.shortcut.bodytext) },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }